import React, { useEffect, useState } from 'react';
import { OnboardingStageProps } from '../../Classes';
import { Button, Header, Icon, Message, Toast } from 'react-frontier';
import { Link } from 'react-router-dom';
import API from '../../API';
import { useUser } from '../../Hooks';

var OnboardingThanks = (props: OnboardingStageProps)=>{
	var { refresh } = useUser();
	
	useEffect(()=>{
		API.getOnboardingUser().then(res=>{
			if(res.error) return Toast.error(res.message);
		}).catch(err=>{})
	}, []);

	return <div className="tp onboarding-thanks">
		<Header text={'¡Todo listo!'} subtext={'Onboarding completado'} />
		<Icon name='check-circle' />
		<div className="info">
			<b>Hemos recaudado tu información</b> <br />
			Gracias por completar el proceso de validación de usuario. A continuación podrás continuar usando la plataforma.
			<br /> <br />
			Quedan algunas otras configuraciones que tendrás que hacerle a tu cuenta para poder usar la plataforma por completo:
		</div>

		<Link to={'/profile/bank'} onClick={props.onFinish}>
			<Message>
				<Icon name='money-bill-wave' />
				<div className="info">
					<div className="title">Cuentas bancarias</div>
					<div className="details">
						Para que puedas sacar el dinero que consigas usando la plataforma, tendrás que dar de alta una cuenta bancaria.
					</div>
				</div>
			</Message>
		</Link>
		<Link to={'/profile'} onClick={props.onFinish}>
			<Message>
				<Icon name='id-badge' />
				<div className="info">
					<div className="title">Foto de perfil</div>
					<div className="details">
						Podrás subir tu foto de perfil para personalizar mas tu perfil de trabajador.
					</div>
				</div>
			</Message>
		</Link>

		<Button color='black' text='Continuar a Ebentu' style={{ marginTop: 15 }} onClick={props.onFinish} />
	</div>
}

export default OnboardingThanks;